export default {
	install(Vue) {
		Vue.prototype.$capitalize = function (text) {
			return text.charAt(0).toUpperCase() + text.slice(1);
		};

		Vue.prototype.$plain = function (o) {
			if (o === undefined || o === null) {
				return o;
			}

			try {
				return JSON.parse(JSON.stringify(o));
			} catch (error) {
				return o;
			}
		};

		Vue.prototype.$baseUrl = function () {
			if (process.env.NODE_ENV === "development") return "http://localhost:8080";
			if (process.env.NODE_ENV === "rc") return "https://rc.fresk.app";
			if (process.env.NODE_ENV === "beta") return "https://beta.fresk.app";
			if (process.env.NODE_ENV) return "https://my.fresk.app";
		};
	}
};